import React, { useMemo } from "react";
import { ErrorIconSize } from "./ErrorIconSize";

export const LoadingCircleIcon = (props: {size?: ErrorIconSize}): JSX.Element => {
    const {size = 'medium'} = props;
    const svgProps = useMemo(() => (
        size == 'medium' ? { width: 225, height: 225 } : { width: 112.5, height: 112.5 }
    ), [size]);
    
    return (
        <svg {...svgProps} viewBox="0 0 225 225" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M112.5 18.75C60.7233 18.75 18.75 60.7233 18.75 112.5C18.75 164.277 60.7233 206.25 112.5 206.25C164.277 206.25 206.25 164.277 206.25 112.5C206.25 107.796 205.903 103.172 205.235 98.6537C204.394 92.9779 208.549 87.5 214.287 87.5C218.922 87.5 222.988 90.703 223.691 95.2848C224.553 100.897 225 106.646 225 112.5C225 174.632 174.632 225 112.5 225C50.368 225 0 174.632 0 112.5C0 50.368 50.368 0 112.5 0C141.313 0 167.597 10.832 187.5 28.646V15.625C187.5 10.4473 191.697 6.25 196.875 6.25C202.053 6.25 206.25 10.4473 206.25 15.625V53.125C206.25 58.3027 202.053 62.5 196.875 62.5H159.375C154.197 62.5 150 58.3027 150 53.125C150 47.9473 154.197 43.75 159.375 43.75H176.238C159.512 28.2353 137.114 18.75 112.5 18.75Z" fill="#CDD2DD"/>
        </svg>
    );
}
